<template>
  <div class="camptrac-order">
    <v-card class="d-flex flex-column">
      <v-card-title class="py-2">
        <div class="d-flex justify-start align-center full-width">
          <access-card-icon
            :size="denseHeader ? '36' : '60'"
            class="pl-0 pr-4"
            :active="isReadyForScanning"
          ></access-card-icon>
          <div class="pr-2 d-none d-xl-block">Accesskort by</div>
          <img
            :src="require('@/assets/images/camptrac_logo.svg')"
            height="28"
          />
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <div class="tabs-container flex-grow-1 d-flex flex-column">
        <camptrac-card-list
          :booking="booking"
          :is-open="isOpen"
          :is-loading="isLoading"
          :is-ready-for-scanning="isReadyForScanning"
          @start-add-new-card="startAddNewCard"
          @abort-add-new-card="abort"
        ></camptrac-card-list>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AccessCardIcon from '@/components/common/AccessCardIcon.vue'
import CamptracCardList from './CardList.vue'

export default {
  name: 'CamptracOrder',
  components: {
    AccessCardIcon,
    CamptracCardList
  },
  props: {
    booking: Object,
    isOpen: Boolean,
    isLoading: Boolean,
    denseHeader: Boolean,
    activateReaderOnMount: Boolean
  },
  data: () => ({
    isReadyForScanning: false,
    isRegeneratingPincode: false
  }),
  computed: {
    ...mapState(
      {
        isElectron: state => state.isElectron
      }
    ),
    isCheckedIn: function () {
      return !!this.booking?.checked_in_at
    }
  },
  methods: {
    startAddNewCard: function () {
      this.isReadyForScanning = true
      window.scannerVM.requestInput('camptrac/addCard', this.booking, true) // OBS: tredje param efterfrågar flera inputs, requestInput återställs då inte efter första input och är viktigt att abort körs när det är klart
    },
    abort: function () {
      this.isReadyForScanning = false
      window.scannerVM.abortInputRequest('camptrac/addCard')
    }
  },
  watch: {
    isCheckedIn: function (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      if (this.isOpen && this.activateReaderOnMount && this.isCheckedIn) {
        this.startAddNewCard()
      }
    },
    isOpen: function (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      if (!this.isOpen) {
        this.abort()
      }
      if (this.isOpen && this.activateReaderOnMount && this.isCheckedIn) {
        this.startAddNewCard()
      }
    }
  },
  mounted: function () {
    if (this.activateReaderOnMount && this.isOpen && this.isCheckedIn) {
      this.startAddNewCard()
    }
  }
}
</script>
